import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { captureException } from '@sentry/angular';
import { initSentry } from './app/core/monitoring/sentry.init';

// Sentry en premier : capture aussi les échecs de bootstrap.
// No-op complet si SENTRY_DSN (runtime) est vide.
initSentry();

// Silence non-actionable framework and third-party console noise in development
const ignoredTerms = [
  'locize',
  'i18next is made possible by our own product',
  'managed localization',
  'sanitizing html',
  'allowsignalwrites',
  'ng0751',
  'defer',
  'hot module replacement',
  'development mode'
];

function shouldIgnore(...args: any[]): boolean {
  const msg = args.map(arg => {
    if (!arg) return '';
    if (arg instanceof Error) return arg.message + ' ' + arg.stack;
    if (typeof arg === 'object') {
      try {
        return arg.message || String(arg) || JSON.stringify(arg);
      } catch {
        return String(arg);
      }
    }
    return String(arg);
  }).join(' ').toLowerCase();

  return ignoredTerms.some(term => msg.includes(term.toLowerCase()));
}

const originalLog = console.log;
console.log = function (...args: any[]) {
  if (shouldIgnore(...args)) return;
  originalLog.apply(console, args);
};

const originalWarn = console.warn;
console.warn = function (...args: any[]) {
  if (shouldIgnore(...args)) return;
  originalWarn.apply(console, args);
};

const originalInfo = console.info;
console.info = function (...args: any[]) {
  if (shouldIgnore(...args)) return;
  originalInfo.apply(console, args);
};

declare var Formio: any;
if (typeof Formio !== 'undefined') {
  Formio.setBaseUrl('');
  Formio.setProjectUrl('');
  Formio.setToken(null);

  if (Formio.cdn?.setOverrideUrl) {
    Formio.cdn.setOverrideUrl('flatpickr-formio', '/assets/vendor');
    Formio.cdn.setOverrideUrl('shortcut-buttons-flatpickr', '/assets/vendor');
  }

  if (typeof Formio.clearCache === 'function') {
    Formio.clearCache();
  }

  if (Formio.Utils && !Formio.Utils.evaluate._isPatched) {
    const originalEvaluate = Formio.Utils.evaluate;
    const errorCache = new Set<string>();

    Formio.Utils.evaluate = function (func: any, args: any, ret: any, tokenize: any) {
      const cacheKey = typeof func === 'string' ? func : String(func);

      if (errorCache.has(cacheKey)) {
        return ret;
      }

      try {
        return originalEvaluate.call(this, func, args, ret, tokenize);
      } catch (err: any) {
        if (err instanceof TypeError && err.message && (
          err.message.includes("Cannot read properties of null") ||
          err.message.includes("Cannot set properties of null") ||
          err.message.includes("Cannot read property") ||
          err.message.includes("Cannot access")
        )) {
          errorCache.add(cacheKey);
          return ret;
        }
        throw err;
      }
    };
    Formio.Utils.evaluate._isPatched = true;
  }
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    sessionStorage.removeItem('chunk_reload_attempted');
  })
  .catch((err) => {
    // Un échec ici = page blanche : il doit remonter à Sentry et rester
    // visible en console (l'ancien catch avalait tout silencieusement).
    captureException(err);
    console.error('[App] Échec du bootstrap', err);
  });
